import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RuleInterface } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { WORKFLOW_TRIGGERS } from '../../../../component-loader/trigger-definitions';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { NoRules } from '../../common';

@Component({
  selector: 'automata-no-rules-panel',
  templateUrl: './no-rules-panel.component.html',
  imports: [CommonModule, TranslateModule, GalaxyAlertModule],
  styleUrls: ['./no-rules-panel.component.scss'],
})
export class NoRulesPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  nameKey = '';
  alertKey = '';

  ngOnInit(): void {
    super.ngOnInit();
    const triggerDefinitions: { [taskKey: string]: any } = WORKFLOW_TRIGGERS;
    this.nameKey = triggerDefinitions?.[this.taskDefinitionId]?.name;
    this.alertKey = triggerDefinitions?.[this.taskDefinitionId]?.panelAlert;

    // Nothing to load so we can always save this trigger.
    this.savingEnabled$.next(true);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return NoRules();
  }

  fillRuleValues(_rules: RuleInterface[]): RuleInterface[] {
    //Normally you'd just return rules here if there was nothing to modify but I want to override the old rules with
    //the NoRules for a migration
    return NoRules();
  }
}
